
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: process.env.VUE_BASE,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@modules/website/pages/Login.vue')
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('@modules/website/pages/Logout.vue')
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@modules/website/pages/Register.vue')
    },
    {
      path: '/forgot',
      name: 'ForgotPassword',
      component: () => import('@modules/website/pages/ForgotPassword.vue')
    },
    {
      path: '/reset',
      name: 'ResetPassword',
      component: () => import('@modules/website/pages/ResetPassword.vue')
    },
    {
      path: '/brands/invitation/:token',
      name: 'BrandRepInvitationEditPage',
      component: () => import('@modules/website/pages/Invitation/BrandRepInvitationEditPage.vue')
    },
    {
      path: '/organizers/invitation/:token',
      name: 'OrganizerInvitationEditPage',
      component: () => import('@modules/website/pages/Invitation/OrganizerInvitationEditPage.vue')
    },
    {
      path: '/browser',
      name: 'Browser',
      component: () => import('@modules/website/pages/Browser.vue')
    },
    {
      path: '/campaign/:campaignId/shared',
      name: 'SharedCampaignShowPage',
      component: () => import('@modules/website/pages/SharedCampaign/SharedCampaignShowPage.vue')
    },
    {
      path: '/status',
      name: 'StatusCheckShowPage',
      component: () => import('@modules/website/pages/StatusCheck/StatusCheckShowPage.vue')
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: () => import('@modules/website/pages/Maintenance.vue')
    },
    {
      path: '/store/:storefrontSlug',
      name: 'OrganizerStorefrontShowPage',
      component: () => import('@modules/website/pages/OrganizerStorefront/OrganizerStorefrontShowPage.vue')
    },
    {
      path: '/store/wework/event-terms',
      name: 'WeworkEventTermsShowPage',
      component: () => import('@modules/website/pages/OrganizerStorefront/terms/WeworkEventTermsShowPage.vue')
    },
    {
      path: '/organizer-recaps/:token',
      name: 'OrganizerRecapShowPage',
      component: () => import('@modules/website/pages/OrganizerRecap/OrganizerRecapShowPage.vue')
    },
    {
      path: '/organizer-recaps/:token/edit',
      name: 'OrganizerRecapEditPage',
      component: () => import('@modules/website/pages/OrganizerRecap/OrganizerRecapEditPage.vue')
    },
  ]
})

export default router